import { useCallback, useMemo } from 'react';
import { useOptionClick } from './useOptionClick';
import { stateKeys } from '../model';
import { filterOptions } from '../utils';

const {
  visible: visibleKey,
  search: searchKey,
  options: optionsKey,
  filteredOptions: filteredOptionsKey,
  currentValue: currentValueKey,
} = stateKeys;

export const useCreateHandlers = ({ store, valueRef }) => {
  const handleClose = useCallback(
    (props = {}) => {
      // закрываем dropdown
      store.setProps({ [visibleKey]: false });
      // потом сбрасываем остальные значения, чтобы до закрытия не срабатывало и не было мельканий
      store.setProps({ [searchKey]: '', ...props });
    },
    [store]
  );

  const handleSearchChange = useCallback(
    (value) => {
      const options = store.getState()[optionsKey];

      const filteredOptions = filterOptions({
        options,
        search: value,
        createSearch: valueRef.current.createSearch,
        value: valueRef.current.value,
      });

      store.setProps({
        [searchKey]: value,
        [filteredOptionsKey]: filteredOptions,
      });
    },
    [store, valueRef]
  );

  const handleValueChange = useCallback(
    (value) => {
      store.setProps({ [currentValueKey]: value });
    },
    [store]
  );

  const handleOptionClick = useOptionClick({
    store,
    valueRef,
    onClose: handleClose,
    onValueChange: handleValueChange,
  });

  const handleCancel = useCallback(() => {
    handleClose({ [currentValueKey]: valueRef.current.value });
  }, [handleClose, valueRef]);

  const handleOk = useCallback(() => {
    valueRef.current.onChange(store.getState()[currentValueKey]);
    handleClose();
  }, [valueRef, store, handleClose]);

  const handleVisibleChange = useCallback(
    (visible) => {
      visible ? store.setProps({ [visibleKey]: true }) : handleCancel();
    },
    [store, handleCancel]
  );

  const handlers = useMemo(
    () => ({
      onSearchChange: handleSearchChange,
      onOptionClick: handleOptionClick,
      onCancel: handleCancel,
      onOk: handleOk,
      onVisibleChange: handleVisibleChange,
      onValueChange: handleValueChange,
    }),
    [
      handleSearchChange,
      handleOptionClick,
      handleCancel,
      handleOk,
      handleVisibleChange,
      handleValueChange,
    ]
  );

  return handlers;
};
